import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Crown } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Text, Box } from "@similarweb/ui-components/foundations";

import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";

import type { FiltersCategoryWithCountItem } from "../../types/category";

import { StyledChip } from "./styles";

type Props = {
    isSelected: boolean;
    item: FiltersCategoryWithCountItem;
    onClick: (id: FiltersCategoryWithCountItem["id"]) => void;
};

export const FilterCategoryChip = ({ isSelected, item, onClick }: Props): ReactElement => {
    const { translate } = useTranslate();

    return (
        <StyledChip
            $isSelected={isSelected}
            data-automation={`filters-list.category-chip.${item.id}`}
            onClick={() => onClick(item.id)}
        >
            <Box>
                <Text fontVariant="caption">{translate(item.titleKey)}</Text>
                {item.count ? <StyledParenthesisedContent>{item.count}</StyledParenthesisedContent> : null}
            </Box>

            {item.withIndicator ? <Badge type="new" /> : null}

            {item.isLocked ? (
                <Crown
                    size="xs"
                    color={colorsPalettes.indigo[300]}
                />
            ) : null}
        </StyledChip>
    );
};
